<template>
    <div class="addEditeUser">
        <el-dialog
                :title="dialog.title"
                width="800px"
                :visible.sync="dialog.show"
                :close-on-click-modal='dialog.clickModal'
                :close-on-press-escape='dialog.pressEscape'
                :modal-append-to-body="false">
            <el-form :model="formData" status-icon :rules="rules" ref="form" label-width="100px" class="myform">
                <!-- <el-row>
                    <el-col :span="24">
                        <el-form-item label="头像" prop="avatar">
                            <el-upload
                                    class="avatar-uploader"
                                    :action="action"
                                    :headers="headers"
                                    name="file"
                                    :limit="1"
                                    :show-file-list="false"
                                    :on-success="handleAvatarSuccess"
                                    :before-upload="beforeAvatarUpload">
                                <img v-if="formData.avatar" :src="formData.avatar" class="avatar1">
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                </el-row> -->
                <el-row>
                    <el-col :span="10">
                        <el-form-item label="用户名" prop="username">
                            <el-input :disabled="formData.type != 'add'" onkeyup="value=value.replace(/[\u4E00-\u9FA5]/g,'')" type="text" v-model="formData.username" autocomplete="off"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="10">
                        <el-form-item label="密码" prop="password">
                            <el-input v-model="formData.password" autocomplete="off" show-password></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="10">
                        <el-form-item label="昵称" prop="nickName">
                            <el-input type="text" v-model="formData.nickName" autocomplete="off"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="10">
                        <el-form-item label="手机号" prop="mobile">
                            <el-input type="text" v-model="formData.mobile" autocomplete="off"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>


                <el-row>
                    <el-col :span="10">
                        <el-form-item label="Email" prop="email">
                            <el-input type="text" v-model="formData.email" autocomplete="off"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="10">
                        <el-form-item label="角色" prop="roleId">
                            <el-select v-model="formData.roleId" placeholder="请选择角色">
                                <el-option
                                    v-for="item in selectData"
                                    :label="item.roleDesc"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-form-item label="状态" prop="status">
                    <el-switch
                        v-model="formData.status"
                        :active-value="0"
                        :inactive-value="1">
                    </el-switch>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitForm('form')">确定</el-button>
                <el-button @click="dialog.show = false">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import { putUser,getRoleAll } from "@/api/index";
    import { base } from '../../libs/axios';
    import md5 from 'js-md5';

    export default {
        name: "addUser",
        props: {
            dialog: Object,
            formData: Object
        },
        data() {
            var validatePass = (rule, value, callback) => {
                let type = this.formData.type
                if (type === 'add' && value === '') {
                    callback(new Error('请输入密码'));
                } else {
                    callback();
                }
            };
            return {
                action: base+'/upload/avatar',
                headers: {
                    'token': sessionStorage.getItem('accessToken')
                },
                selectData: [],
                rules: {
                    username: [
                        { required: true, message:'请输入用户名', trigger: 'blur' },
                        { min: 6, max: 15, message:'长度必须6-15个字符', trigger: 'blur'}
                    ],
                    password: [
                        {  validator: validatePass, trigger: 'blur' }
                    ],
                    nickName: [
                        { required: true, message:'请输入昵称', trigger: 'blur' }
                    ],
                    email: [
                        { pattern:  /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/, message: '邮箱必须合法', trigger: 'blur' }
                    ],
                    mobile: [
                        { required: true, message:'请输入手机号', trigger: 'blur' },
                        { pattern: /^1[34578]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur'}
                    ],
                    roleId: [
                        { required: true, message:'请选择角色', trigger: 'blur' }
                    ]
                }
            };
        },
        methods: {
            handleAvatarSuccess(res, file) {
                if (res.success == true) {
                    this.formData.avatar = res.result
                }else{
                    this.$message({
                        showClose: true,
                        message: res.message,
                        type: 'error'
                    })
                }
            },
            beforeAvatarUpload(file) {
                const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
                const isLt2M = file.size / 1024 / 1024 < 2;

                if (!isJPG) {
                    this.$message.error('上传头像图片只能是 JPG,PNG 格式!');
                }
                if (!isLt2M) {
                    this.$message.error('上传头像图片大小不能超过 2MB!');
                }
                return isJPG && isLt2M;
            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        putUser({
                            id: this.formData.id,
                            username: this.formData.username,
                            password: this.formData.password == null? null:md5(this.formData.password),
                            avatar: this.formData.avatar,
                            nickName: this.formData.nickName,
                            mobile: this.formData.mobile,
                            roleId: this.formData.roleId,
                            email: this.formData.email,
                            status: this.formData.status,
                            type: this.formData.type
                        }).then(res => {
                            if (res.success == true) {
                                this.$refs[formName].resetFields()
                                this.$emit('result', this.formData.type)
                            }else{
                                this.$message({
                                    showClose: true,
                                    message: res.message,
                                    type: 'error'
                                })
                            }
                        });
                    } else {
                        return false;
                    }
                });
            },
            getRoleAll(){
                let that = this
                getRoleAll({
                    pageIndex: 1,
                    size: 50
                }).then(res => {
                    if (res.success == true) {
                        that.selectData = res.result.list
                    }else{
                        this.$message({
                            showClose: true,
                            message: res.message,
                            type: 'error'
                        })
                    }
                });
            }
        },
        created(){
            this.getRoleAll()
        }
    };
</script>
<style lang="scss">
    .addEditeUser {
        .avatar-uploader .el-upload {
            border: 1px dashed #d9d9d9;
            border-radius: 6px;
            cursor: pointer;
            position: relative;
            overflow: hidden;
        }
        .avatar-uploader .el-upload:hover {
            border-color: #409EFF;
        }
        .avatar-uploader-icon {
            font-size: 28px;
            color: #8c939d;
            width: 178px;
            height: 178px;
            line-height: 178px;
            text-align: center;
        }
        .avatar1 {
            width: 178px;
            height: 178px;
            display: block;
        }
        .myform{
            width: 100%!important;
        }
    }
</style>
